import {
    put, all, select, takeLatest,
} from 'redux-saga/effects';
import _ from 'underscore';

import {
    REFUSE_ALL_COOKIES,
    getAllCookiesIdsSelector,
    setCookie,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    const cookiesIds = yield select(getAllCookiesIdsSelector);
    yield all(_.map(cookiesIds, (cookieId) => (
        put(setCookie(cookieId, false))
    )));
}

export function* watch() {
    yield takeLatest(REFUSE_ALL_COOKIES, callAction);
}
